module.exports = __webpack_public_path__ + "assets/media/bot-avatar.2207ec3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/OnboardingBotPreview/bot-avatar.svg
// module id = 3003
// module chunks = 0